import React from 'react';

export const percentRenderer = (params: any) => params?.value ? (
  <span className="ag-cell-value">
    {!isNaN(params?.value) ? `${Number(params?.value * 100).toFixed(2)}%` : params?.value}
  </span>
) : params?.valueFormatted;
